import script from "./DesktopHeaderTop.vue?vue&type=script&setup=true&lang=js"
export * from "./DesktopHeaderTop.vue?vue&type=script&setup=true&lang=js"

import "./DesktopHeaderTop.vue?vue&type=style&index=0&id=15c35d4c&lang=css"

const __exports__ = script;

export default __exports__